"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameScoreData = void 0;
var LocalStorageHandler_1 = require("../LocalStorageHandler");
var GameScoreData = /** @class */ (function () {
    function GameScoreData() {
        this.dataHandler = new LocalStorageHandler_1.LocalStorageHandler();
    }
    GameScoreData.prototype.save = function (score) {
        this.dataHandler.saveItem(GameScoreData.SCORE_DATA_KEY, score);
    };
    GameScoreData.prototype.get = function () {
        var data = this.dataHandler.getItem(GameScoreData.SCORE_DATA_KEY);
        if (data == null) {
            data = { completedLevels: [], highestScore: 0 };
            this.save(data);
        }
        return data;
    };
    GameScoreData.SCORE_DATA_KEY = "GameScoreData";
    return GameScoreData;
}());
exports.GameScoreData = GameScoreData;
